<div class="sabis-document-viewer">
  <sabis-ngx-dialog scTitle="Preview Document">
    <div modal-body>
      <ngx-doc-viewer
        [url]="documentURL"
        [viewer]="viewer"
        disableContent="all"></ngx-doc-viewer>
    </div>

    <div modal-footer>
      <sabis-ngx-button (click)="onCloseButtonClick()">
        Close
      </sabis-ngx-button>
    </div>
  </sabis-ngx-dialog>
</div>
